/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Tile_Payable_HintInputs */



/**
* | output |
* | --- |
* | "Accrued + approved, not yet transferred" |
*
* @param {Partner_Admin_Commission_Tile_Payable_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_tile_payable_hint = /** @type {((inputs?: Partner_Admin_Commission_Tile_Payable_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Tile_Payable_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufgelaufen + freigegeben, noch nicht ausgezahlt")
	return /** @type {LocalizedString} */ ("Accrued + approved, not yet transferred")
});